const plural = {
  "(quiz)$": "$1zes",
  "^(ox)$": "$1en",
  "([m|l])ouse$": "$1ice",
  "(matr|vert|ind)ix|ex$": "$1ices",
  "(x|ch|ss|sh)$": "$1es",
  "([^aeiouy]|qu)y$": "$1ies",
  "(hive)$": "$1s",
  "(?:([^f])fe|([lr])f)$": "$1$2ves",
  sis$: "ses",
  "([ti])um$": "$1a",
  "(buffal|tomat)o$": "$1oes",
  "(bu)s$": "$1ses",
  "(alias|status)$": "$1es",
  "(octop|vir)us$": "$1i",
  "(ax|test)is$": "$1es",
  s$: "s",
  $: "s",
};

export default function pluralize(word: string): string {
  var pluralRules = Object.keys(plural) as (keyof typeof plural)[];

  for (var i = 0; i < pluralRules.length; i++) {
    var rule = new RegExp(pluralRules[i]);

    if (rule.test(word)) {
      return word.replace(rule, plural[pluralRules[i]]);
    }
  }

  return word + "s";
}
